export const GET_MONEY_STATISTICS = 'GET_MONEY_STATISTICS';
export const GET_MONEY_STATISTICS_DONE = 'GET_MONEY_STATISTICS_DONE';

export const GET_CUS_RECONCILIATION = 'GET_CUS_RECONCILIATION';
export const GET_CUS_RECONCILIATION_DONE = 'GET_CUS_RECONCILIATION_DONE';
export const GET_CUS_RECONCILIATION_PAYMENT_STATEMENT = 'GET_CUS_RECONCILIATION_PAYMENT_STATEMENT';
export const GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_DONE = 'GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_DONE';
export const GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT = 'GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT';
export const GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT_DONE = 'GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT_DONE';